import { colors, spacing, borderRadius, shadows, typography, breakpoints } from './tokens';

export const theme = {
  colors,
  spacing,
  borderRadius,
  shadows,
  typography,
  breakpoints,
};

export type Theme = typeof theme;
